'use client';

import { useLocale, useTranslations } from 'next-intl';
import { RiGithubFill, RiGoogleFill } from 'react-icons/ri';
import { toast } from 'sonner';
import { signIn } from '@/core/auth/client';
import { useRouter } from '@/core/i18n/navigation';
import { defaultLocale } from '@/config/locale';
import { Button } from '@/shared/components/ui/button';
import { useAppContext } from '@/shared/contexts/app';
import { trackSignUpComplete } from '@/shared/lib/analytics-events';
import { cn } from '@/shared/lib/utils';
import { Button as ButtonType } from '@/shared/types/blocks/common';
export function SocialProviders({
  configs,
  callbackUrl,
  loading,
  setLoading
}: {
  configs: Record<string, string>;
  callbackUrl: string;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}) {
  const t = useTranslations('common.sign');
  const router = useRouter();
  const {
    setIsShowSignModal
  } = useAppContext();
  if (callbackUrl) {
    const locale = useLocale();
    if (locale !== defaultLocale && callbackUrl.startsWith('/') && !callbackUrl.startsWith(`/${locale}`)) {
      callbackUrl = `/${locale}${callbackUrl}`;
    }
  }
  const handleSignIn = async ({
    provider
  }: {
    provider: string;
  }) => {
    await signIn.social({
      provider: provider,
      callbackURL: callbackUrl
    }, {
      onRequest: ctx => {
        setLoading(true);
      },
      onResponse: ctx_0 => {
        setLoading(false);
        setIsShowSignModal(false);
      },
      onSuccess: ctx_1 => {
        // Track successful sign in
        trackSignUpComplete();
      },
      onError: (e: any) => {
        toast.error(e?.error?.message || 'sign in failed');
        setLoading(false);
      }
    });
  };
  const providers: ButtonType[] = [];
  if (configs.google_auth_enabled === 'true') {
    providers.push({
      name: 'google',
      title: t('google_sign_in_title'),
      icon: <RiGoogleFill />,
      onClick: () => handleSignIn({
        provider: 'google'
      })
    });
  }
  if (configs.github_auth_enabled === 'true') {
    providers.push({
      name: 'github',
      title: t('github_sign_in_title'),
      icon: <RiGithubFill />,
      onClick: () => handleSignIn({
        provider: 'github'
      })
    });
  }
  return <div className={cn('flex w-full items-center gap-2', 'flex-col justify-between')}>
      {providers.map(provider_0 => <Button key={provider_0.name} variant="outline" className={cn('w-full gap-2')} disabled={loading} onClick={provider_0.onClick}>
          {provider_0.icon}
          <h3>{provider_0.title}</h3>
        </Button>)}
    </div>;
}